/* ============================================================
   MeAyurv PDP — shared interactions (accordion).
   Event-delegated + init-guarded so a double-include or a
   Sense section re-render can't stack duplicate listeners.
   Used by: FAQ (P) and Detail accordion (N).
   ============================================================ */
(function () {
  if (window.__meayurvPdpInit) return;
  window.__meayurvPdpInit = true;

  document.addEventListener('click', function (e) {
    var head = e.target.closest('.mpdp-acc__head');
    if (!head) return;
    var item = head.closest('.mpdp-acc__item');
    var acc = head.closest('.mpdp-acc');
    if (!item || !acc) return;

    var willOpen = !item.classList.contains('is-open');

    if (willOpen && !acc.hasAttribute('data-allow-multiple')) {
      acc.querySelectorAll('.mpdp-acc__item.is-open').forEach(function (other) {
        if (other === item) return;
        other.classList.remove('is-open');
        var b = other.querySelector('.mpdp-acc__head');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    item.classList.toggle('is-open', willOpen);
    head.setAttribute('aria-expanded', String(willOpen));
  });

  // --- Pincode / delivery-ETA check (front-end fake; Magic is the real COD gate) ---
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-mpdp-pincode-input]');
    if (!input) return;
    input.value = input.value.replace(/\D/g, '').slice(0, 6);
    var box = input.closest('[data-mpdp-pincode]');
    if (!box) return;
    var btn = box.querySelector('[data-mpdp-pincode-btn]');
    if (btn) btn.disabled = !/^\d{6}$/.test(input.value);
    var res = box.querySelector('[data-mpdp-pincode-result]');
    if (res) res.hidden = true;
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mpdp-pincode-btn]');
    if (!btn || btn.disabled) return;
    var box = btn.closest('[data-mpdp-pincode]');
    if (!box) return;
    var res = box.querySelector('[data-mpdp-pincode-result]');
    if (res) res.hidden = false;
  });
})();

/* ============================================================
   Recently viewed — writer half. Every product-page visit
   records the handle in localStorage 'may:recently-viewed'
   (newest first, deduped, max 8). The reader half is
   sections/meayurv-recently-viewed.liquid (search page strip),
   which fetches the real meayurv-card-product cards via the
   Section Rendering API.
   ============================================================ */
(function () {
  if (window.__mayRecentWriter) return;
  window.__mayRecentWriter = true;
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var handle = decodeURIComponent(m[1]);
  try {
    var KEY = 'may:recently-viewed';
    var list = JSON.parse(localStorage.getItem(KEY) || '[]');
    if (!Array.isArray(list)) list = [];
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));
  } catch (e) { /* private mode / blocked storage — feature simply stays off */ }
})();
